import i18n from 'modules/core/lib/i18n'

enum FrequencyOptions {
  single = 'single',
  daily = 'daily',
  weekly = 'weekly',
  bi_weekly = 'bi_weekly',
  monthly = 'monthly',
  bi_monthly = 'bi_monthly',
  quarterly = 'quarterly',
  semiannual = 'semiannual',
  annual = 'annual',
}

export const DEFAULT_FREQUENCY_OPTION = FrequencyOptions.monthly

export const frequencyOptionLabel = (): Map<string, string> =>
  new Map([
    [FrequencyOptions.daily, i18n.t('surveys.form.periodicity.daily')],
    [FrequencyOptions.weekly, i18n.t('surveys.form.periodicity.weekly')],
    [FrequencyOptions.bi_weekly, i18n.t('surveys.form.periodicity.bi_weekly')],
    [FrequencyOptions.monthly, i18n.t('surveys.form.periodicity.monthly')],
    [FrequencyOptions.bi_monthly, i18n.t('surveys.form.periodicity.bi_monthly')],
    [FrequencyOptions.quarterly, i18n.t('surveys.form.periodicity.quarterly')],
    [FrequencyOptions.semiannual, i18n.t('surveys.form.periodicity.semiannual')],
    [FrequencyOptions.annual, i18n.t('surveys.form.periodicity.yearly')],
  ])

const cycleOptionsAvailable: FrequencyOptions[] = [
  FrequencyOptions.daily,
  FrequencyOptions.weekly,
  FrequencyOptions.bi_weekly,
  FrequencyOptions.monthly,
  FrequencyOptions.bi_monthly,
  FrequencyOptions.quarterly,
  FrequencyOptions.semiannual,
  FrequencyOptions.annual,
]

export const frequencySelectOptions = () => {
  const options: { value: FrequencyOptions; label: string }[] = []
  cycleOptionsAvailable.forEach((frequency) => {
    options.push({
      value: frequency,
      label: frequencyOptionLabel().get(frequency) ?? '',
    })
  })
  return options
}
